import template from './template.html'
import Controller from './controller'
import link from './link'

export default [directive]

function directive() {
  return {
    restrict: 'AE',
    template,
    controller: Controller,
    controllerAs: 'vm',
    link
  }
}
